function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, ref, watch } from "vue";
import { getAssetTagList } from "@/api/public_resource";
import { definePropType } from "@types-vue/props";
import _ from "lodash";
export default defineComponent({
    name: "tree-modular",
    props: {
        showAdd: {
            type: definePropType(Boolean),
            default: false
        },
        isRefresh: {
            type: definePropType(Boolean),
            default: false
        },
        isBatch: {
            type: definePropType(Boolean),
            default: false
        },
        params: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var filterText = ref("");
        var treeLoading = ref(false);
        var treeData = ref([]);
        var treeRef = ref();
        var isNoLabel = ref(false);
        var defaultProps = computed(function() {
            return {
                children: "sub_tag_groups",
                label: "name"
            };
        });
        var initTreeData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(val) {
                var assetsTag, _tag_groups, allTreeData;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            treeLoading.value = true;
                            isNoLabel.value = false;
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return getAssetTagList(val);
                        case 5:
                            assetsTag = _ctx.sent;
                            ;
                            allTreeData = [
                                {
                                    id: "",
                                    level: 0,
                                    name: props.isBatch ? "\u5168\u90E8\u6807\u7B7E" : "\u5168\u90E8",
                                    name_en: "whole",
                                    sub_tag_groups: (_tag_groups = assetsTag.data.data.tag_groups) !== null && _tag_groups !== void 0 ? _tag_groups : []
                                }, 
                            ];
                            treeData.value = assetsTag.data.data.tag_groups && assetsTag.data.data.tag_groups.length ? allTreeData : [];
                            treeLoading.value = false;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](2);
                            treeLoading.value = false;
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        12
                    ]
                ]);
            }));
            return function initTreeData(val) {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return filterText;
        }, function(val) {
            var _$ref;
            (_$ref = treeRef.value) === null || _$ref === void 0 ? void 0 : _$ref.filter(val.value);
        }, {
            deep: true
        });
        watch(function() {
            return props.isRefresh;
        }, function(val) {
            if (val) {
                initTreeData(props.params);
            }
        }, {
            immediate: true,
            deep: true
        });
        watch(function() {
            return props.params;
        }, function(val) {
            initTreeData(val);
        }, {
            immediate: true,
            deep: true
        });
        var filterNode = function(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        };
        var handleNodeClick = function(data) {
            if (!props.isBatch) {
                emit("handleNodeId", data);
            }
        };
        var handleCheckChange = function() {
            if (props.isBatch) {
                var _$ref;
                var childNodeKeyList = (_$ref = treeRef.value) === null || _$ref === void 0 ? void 0 : _$ref.getCheckedNodes();
                var childKeyList = _.map(childNodeKeyList.filter(function(item) {
                    return item.level === -1;
                }), "id");
                emit("handleNodeId", String(childKeyList));
            }
        };
        var noLabelEvent = function() {
            var // treeRef.value?.setCheckedKeys([])
            _$ref;
            (_$ref = treeRef.value) === null || _$ref === void 0 ? void 0 : _$ref.setCurrentKey(null);
            emit("handleNodeId", isNoLabel.value);
        };
        return {
            treeRef: treeRef,
            treeData: treeData,
            treeLoading: treeLoading,
            filterText: filterText,
            defaultProps: defaultProps,
            isNoLabel: isNoLabel,
            filterNode: filterNode,
            handleNodeClick: handleNodeClick,
            handleCheckChange: handleCheckChange,
            noLabelEvent: noLabelEvent
        };
    }
});
